import { BeelineResult } from '../beelineLp/BeelineLanding';

export default function Beeline1Failed() {
  return <BeelineResult lpKey="beeline1" outcome="failed" variant={1} />;
}
